import { User } from '@shared/types/user';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Interface for the authentication state
 */
interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;

  // Actions
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  setAuth: (token: string, user: User) => void;
  clearAuth: () => void;
  logout: () => void;
}

/**
 * Auth store with persistence
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,

      // Set token
      setToken: (token: string) => set({ token, isAuthenticated: !!token }),

      // Set user data
      setUser: (user: User) => set({ user }),

      // Set auth data (both token and user)
      setAuth: (token: string, user: User) => set({
        token,
        user,
        isAuthenticated: !!token
      }),

      // Clear auth state
      clearAuth: () => set({
        token: null,
        user: null,
        isAuthenticated: false
      }),

      // Logout - alias for clearAuth for better semantic meaning
      logout: () => set({
        token: null,
        user: null,
        isAuthenticated: false
      }),
    }),
    {
      name: 'auth-storage',
    }
  )
);
